import React, { FC, useContext, useState } from "react";
import clsx from "clsx";
import { IonModal } from "@ionic/react";

import { Context } from "../../../store/student";
import { IPulseSurveyAnswer } from "../../../state";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close_no_circle.svg";
import { ReactComponent as WeatherIconRainy } from "../../../assets/images/PulseSurvey/weather_icon_rainy.svg";
import { ReactComponent as WeatherIconThunderstorm } from "../../../assets/images/PulseSurvey/weather_icon_thunderstorm.svg";
import { ReactComponent as WeatherIconCloudy } from "../../../assets/images/PulseSurvey/weather_icon_cloudy.svg";
import { ReactComponent as WeatherIconMostlyCloudy } from "../../../assets/images/PulseSurvey/weather_icon_mostly-cloudy.svg";
import { ReactComponent as WeatherIconPartlyCloudy } from "../../../assets/images/PulseSurvey/weather_icon_partly-cloudy.svg";
import { ReactComponent as WeatherIconSunny } from "../../../assets/images/PulseSurvey/weather_icon_sunny.svg";

import styles from "./Answer.module.scss";

export type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmitAnswers: (answers: IPulseSurveyAnswer) => void;
};

const Answer: FC<Props> = ({ isOpen, onClose, onSubmitAnswers }) => {
  const { contextState } = useContext(Context);
  const [answers, setAnswers] = useState<{
    score: number | null;
    reason: string | null;
    tomorrow_plan: string | null;
  }>({
    score: null,
    reason: null,
    tomorrow_plan: null,
  });
  const weatherIcons = [
    <WeatherIconRainy />,
    <WeatherIconThunderstorm />,
    <WeatherIconCloudy />,
    <WeatherIconMostlyCloudy />,
    <WeatherIconPartlyCloudy />,
    <WeatherIconSunny />,
  ];
  const isAnyAnswered =
    answers.score !== null ||
    answers.reason !== null ||
    answers.tomorrow_plan !== null;

  return (
    <IonModal isOpen={isOpen} className={styles.modal}>
      <div className={styles.overlay} />
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <CloseIcon className={styles.closeIcon} onClick={onClose} />
          <div className={styles.inner}>
            <p className={styles.title}>1日を振り返ろう。</p>
            <p className={styles.question}>
              {contextState.pulse_survey_question.content}
            </p>
            <div className={styles.weatherList}>
              {weatherIcons.map((icon, index) => (
                <div key={index} className={styles.weatherItem}>
                  {icon}
                </div>
              ))}
            </div>
            <div className={styles.score}>
              <span className={styles.label}>NO</span>
              <div className={styles.radioList}>
                {[...Array(contextState.pulse_survey_question.max_score)].map(
                  (_, index) => {
                    const score = index + 1;
                    return (
                      <div key={score} className={styles.radioItem}>
                        <label className={styles.radioButton}>
                          <input
                            className={styles.radioInput}
                            type="radio"
                            name="score"
                            value={score}
                            checked={score === answers.score}
                            onChange={() =>
                              setAnswers(prev => ({
                                ...prev,
                                score,
                              }))
                            }
                          />
                          <span className={styles.radioCustom} />
                        </label>
                      </div>
                    );
                  },
                )}
              </div>
              <span className={styles.label}>YES</span>
            </div>
            <input
              className={clsx(styles.textInput, styles.reason)}
              type="text"
              placeholder="どうしてそう感じたか、具体的に書いてみよう。"
              value={answers.reason ?? ""}
              onChange={e =>
                setAnswers(prev => ({
                  ...prev,
                  reason: e.target.value.trim() === "" ? null : e.target.value,
                }))
              }
            />
            <input
              className={clsx(styles.textInput, styles.tomorrowPlan)}
              type="text"
              placeholder="明日はどんな1日にしたい？"
              value={answers.tomorrow_plan ?? ""}
              onChange={e =>
                setAnswers(prev => ({
                  ...prev,
                  tomorrow_plan:
                    e.target.value.trim() === "" ? null : e.target.value,
                }))
              }
            />
            <button
              className={clsx(styles.saveButton)}
              type="button"
              disabled={!isAnyAnswered}
              onClick={() =>
                onSubmitAnswers({
                  pulse_survey_question_id:
                    contextState.pulse_survey_question.id,
                  ...answers,
                })
              }
            >
              保存
            </button>
          </div>
        </div>
      </div>
    </IonModal>
  );
};

export default Answer;
